"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const CardStyles = styled_components_1.css `
  display: block;
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.backgroundVariant};
  box-shadow: ${(props) => props.closer ? props.theme.shadows.large : props.theme.shadows.normal};
  color: inherit;
  text-decoration: none;

  ${(props) => props.background &&
    styled_components_1.css `
      background-image: url(${props.background});
      background-size: cover;
      background-position: center right;
      background-repeat: no-repeat;
      min-height: 24rem;

      > * {
        max-width: 32rem;
      }
    `}

  ${(props) => props.outlined &&
    styled_components_1.css `
      border: 1px solid ${(props) => props.theme.colors.borderDim};
      background-color: transparent;
      box-shadow: none;
    `}

  ${(props) => props.colorTheme === "orange" &&
    styled_components_1.css `
      background: rgb(231, 177, 80);
      background: linear-gradient(
        180deg,
        rgba(231, 177, 80, 1) 0%,
        rgba(254, 195, 109, 1) 100%
      );
    `}

  ${(props) => props.colorTheme === "blue" &&
    styled_components_1.css `
      background: rgb(89, 113, 236);
      background: linear-gradient(
        180deg,
        rgba(89, 113, 236, 1) 0%,
        rgba(101, 141, 218, 1) 100%
      );
    `}

  ${(props) => props.stretch &&
    styled_components_1.css `
      width: 100%;
      height: 100%;
    `}
`;
exports.CardStyles = CardStyles;
const Card = styled_components_1.default.div `
  ${CardStyles}
`;
exports.Card = Card;
const CardImage = styled_components_1.default.img `
  display: block;
  border-radius: 8px;
  width: 100%;
`;
exports.CardImage = CardImage;
const CardActions = styled_components_1.default.div `
  margin-top: auto;
`;
exports.CardActions = CardActions;
const CardHero = styled_components_1.default.div `
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: ${(props) => props.color};
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  width: 100%;
  padding-top: 42.8571%;
`;
exports.CardHero = CardHero;
